import { render } from "./FilterSmallAgeRange.vue?vue&type=template&id=36e7c082&ts=true"
import script from "./FilterSmallAgeRange.vue?vue&type=script&lang=ts"
export * from "./FilterSmallAgeRange.vue?vue&type=script&lang=ts"

import "./FilterSmallAgeRange.vue?vue&type=style&index=0&id=36e7c082&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__